var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "requisition-ad-crud" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.errors.length > 0
        ? _c("div", { staticClass: "errors mb-4" }, [
            _c(
              "ul",
              _vm._l(_vm.errors, function(error) {
                return _c("li", [
                  _vm._v(
                    "\n                " + _vm._s(error) + "\n            "
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x" }, [
        _c(
          "div",
          { staticClass: "cell large-4 ad-creation-container" },
          [
            _c("div", { staticClass: "approve-header" }, [
              _c("div", { staticClass: "header-text" }, [
                _vm._v(
                  _vm._s(_vm.isPipeline ? "Pipeline" : "Requisition") +
                    " Details"
                )
              ])
            ]),
            _vm._v(" "),
            _c("requisition-crud", {
              attrs: {
                inputsClickable: !_vm.approval,
                flow: "readonly",
                compact: true,
                requisition: _vm.requisition,
                industries: [],
                provinces: [],
                contractTypes: [],
                "hide-status": true,
                "inputs-clickable": true,
                "questions-class": ""
              },
              on: { "input-clicked": _vm.reqInputClicked }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cell large-4 ad-creation-container" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "ad-creation-forms" }, [
            _c(
              "form",
              { attrs: { method: "POST", enctype: "multipart/form-data" } },
              [
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c("label", [_vm._v("Ad Creation Details")]),
                    _vm._v(" "),
                    _vm.approval
                      ? _c("div", {
                          staticClass: "textarea",
                          domProps: { innerHTML: _vm._s(_vm.adDetails) }
                        })
                      : _c("redactor-control", {
                          attrs: {
                            name: "details",
                            config: {
                              plugins: [
                                "alignment",
                                "table",
                                "fullscreen",
                                "limiter",
                                "counter",
                                "specialchars",
                                "fontcolor"
                              ],
                              callbacks: {}
                            }
                          },
                          model: {
                            value: _vm.adDetails,
                            callback: function($$v) {
                              _vm.adDetails = $$v
                            },
                            expression: "adDetails"
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4" }, [
                  _c("label", [_vm._v("Display Title")]),
                  _vm._v(" "),
                  _vm.approval
                    ? _c("div", {
                        staticClass: "textarea",
                        domProps: { innerHTML: _vm._s(_vm.adDisplayTitle) }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.adDisplayTitle,
                            expression: "adDisplayTitle"
                          }
                        ],
                        attrs: { name: "display_title", type: "text" },
                        domProps: { value: _vm.adDisplayTitle },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.adDisplayTitle = $event.target.value
                          }
                        }
                      })
                ]),
                _vm._v(" "),
                _vm.images.length == 0
                  ? _c("input", {
                      attrs: { name: "images", value: "", type: "hidden" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.approval
                  ? _c(
                      "div",
                      _vm._l(_vm.images, function(image, i) {
                        return _c(
                          "div",
                          { key: "image-" + image.id, staticClass: "mb-4" },
                          [
                            image.file_url
                              ? _c("input", {
                                  attrs: {
                                    name: "images[" + i + "][id]",
                                    type: "hidden"
                                  },
                                  domProps: { value: image.id }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(
                                "\n                                Image #" +
                                  _vm._s(i + 1) +
                                  "\n                                "
                              ),
                              image.file_url
                                ? _c(
                                    "small",
                                    { staticClass: "view-existing" },
                                    [
                                      _vm._v("(Existing: "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: image.file_url
                                          }
                                        },
                                        [_vm._v("view")]
                                      ),
                                      _vm._v(")")
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.approval
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "remove-image",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.removeImages(i)
                                        }
                                      }
                                    },
                                    [_vm._v("Remove")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("InputFileControl", {
                              attrs: {
                                name: "images[" + i + "][file_path]",
                                "label-placeholder": image.file_url
                                  ? image.file_url.split("/").pop()
                                  : "Upload file here"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.setImageFileUrl($event, i)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _c("div", [
                      _vm.images.length > 0
                        ? _c("div", [
                            _c("label", [_vm._v("Image/s Uploaded")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "cell textarea images-uploaded" },
                              [
                                _vm._m(2),
                                _vm._v("  "),
                                _vm._l(_vm.images, function(image, i) {
                                  return image.file_url
                                    ? _c(
                                        "small",
                                        {
                                          key: "uploaded-image-" + image.id,
                                          staticClass: "view-existing"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                href: image.file_url
                                              }
                                            },
                                            [_vm._v("Image #" + _vm._s(i + 1))]
                                          ),
                                          _vm._v(", ")
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell shrink" }, [
                        _c(
                          "button",
                          {
                            staticClass: "mt-3 outlined-grey text-uppercase",
                            attrs: { type: "button" },
                            on: { click: _vm.toggleModal }
                          },
                          [
                            _vm._v(
                              "\n                                View Ad\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          { attrs: { href: _vm.pdfUrl, target: "_blank" } },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "mt-3 outlined-grey text-uppercase",
                                attrs: { type: "button" }
                              },
                              [_vm._v("Export to PDF")]
                            )
                          ]
                        )
                      ])
                    ]),
                _vm._v(" "),
                !_vm.approval
                  ? _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button primary",
                          attrs: { type: "button" },
                          on: {
                            click: function() {
                              return _vm.images.push({
                                file_url_local: "",
                                id: Math.random() * 100
                              })
                            }
                          }
                        },
                        [_vm._v("+ Add Image")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-4 mt-4" },
                  [
                    _c("label", [_vm._v("Approver")]),
                    _vm._v(" "),
                    !_vm.approval
                      ? _c("input", {
                          attrs: { name: "approver_id", type: "hidden" },
                          domProps: {
                            value: _vm.approver ? _vm.approver.id : null
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("vue-select", {
                      attrs: {
                        disabled: _vm.approval,
                        label: "full_name",
                        options: _vm.users
                      },
                      on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(option.full_name) +
                                  " (" +
                                  _vm._s(option.role) +
                                  ")\n                            "
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.approver,
                        callback: function($$v) {
                          _vm.approver = $$v
                        },
                        expression: "approver"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.approval
                  ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c("div", { staticClass: "cell shrink" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button info",
                            attrs: {
                              disabled:
                                !_vm.approver ||
                                _vm.approval ||
                                _vm.adDetails === "",
                              type: "submit",
                              name: "status",
                              value: "created"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                Save Progress\n                            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell shrink" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button success",
                            attrs: {
                              disabled:
                                !_vm.approver ||
                                _vm.approval ||
                                _vm.adDetails === "",
                              type: "submit",
                              name: "status",
                              value: "pending"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                Request Approval\n                            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.approval
                        ? _c("div", { staticClass: "cell shrink" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button outlined-grey",
                                attrs: { type: "button" },
                                on: { click: _vm.toggleModal }
                              },
                              [
                                _vm._v(
                                  "\n                                View Ad\n                            "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "_csrfToken" },
                  domProps: { value: _vm.csrfToken }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.approval
          ? _c(
              "div",
              { staticClass: "cell large-4 ad-creation-container" },
              [
                _vm._m(3),
                _vm._v(" "),
                _vm.ad.status != "approved"
                  ? _c(
                      "form",
                      {
                        staticClass: "approval-form",
                        attrs: { method: "POST" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "mb-4 comments-ad-approval-section" },
                          [
                            _c("label", [_vm._v("Comments")]),
                            _vm._v(" "),
                            _vm.user.id != _vm.ad.approver_id &&
                            _vm.user.role != "super_admin"
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.ad.comments,
                                      expression: "ad.comments"
                                    }
                                  ],
                                  attrs: {
                                    disabled:
                                      _vm.user.id != _vm.ad.approver_id &&
                                      _vm.user.role != "super_admin",
                                    name: "comments",
                                    required: "",
                                    rows: "5"
                                  },
                                  domProps: { value: _vm.ad.comments },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.ad,
                                        "comments",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _c("redactor-control", {
                                  attrs: {
                                    name: "comments",
                                    rows: "5",
                                    config: {
                                      plugins: [
                                        "alignment",
                                        "table",
                                        "fullscreen",
                                        "limiter",
                                        "counter",
                                        "specialchars",
                                        "fontcolor"
                                      ],
                                      callbacks: {}
                                    }
                                  },
                                  model: {
                                    value: _vm.ad.comments,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ad, "comments", $$v)
                                    },
                                    expression: "ad.comments"
                                  }
                                }),
                            _vm._v(" "),
                            _vm.approval
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.adDetails,
                                      expression: "adDetails"
                                    }
                                  ],
                                  staticClass: "d-none",
                                  attrs: { name: "details" },
                                  domProps: { value: _vm.adDetails },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.adDetails = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid-x grid-padding-x" }, [
                          _c("div", { staticClass: "cell" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button alert text-uppercase",
                                attrs: {
                                  disabled:
                                    _vm.user.id != _vm.ad.approver_id &&
                                    _vm.user.role != "super_admin",
                                  type: "submit",
                                  name: "status",
                                  value: "declined"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Decline - Please Update\n                        "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button approve-button mt-2 text-uppercase",
                                attrs: {
                                  disabled:
                                    _vm.user.id != _vm.ad.approver_id &&
                                    _vm.user.role != "super_admin",
                                  type: "submit",
                                  name: "status",
                                  value: "approved"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Approve\n                        "
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "_csrfToken" },
                          domProps: { value: _vm.csrfToken }
                        })
                      ]
                    )
                  : [
                      _c("div", { staticClass: "mb-4 comments-section" }, [
                        _c("label", [_vm._v("Comments")]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "full-textarea",
                          attrs: { disabled: true, required: "", rows: "5" },
                          domProps: { innerHTML: _vm._s(_vm.ad.comments) }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "status" }, [
                        _c("i", {
                          staticClass: "fa",
                          class:
                            _vm.ad.status == "approved"
                              ? "fa-check"
                              : "fa-times"
                        }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("capitalize")(_vm.ad.status)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid-x grid-padding-x" }, [
                        _c(
                          "form",
                          {
                            staticClass: "cell shrink",
                            attrs: {
                              action:
                                "/recruiter/requisitions/publish-to-job-portal/" +
                                _vm.requisition.id,
                              method: "POST"
                            }
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "_csrfToken" },
                              domProps: { value: _vm.csrfToken }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button success",
                                attrs: { type: "submit" }
                              },
                              [
                                _vm._v(
                                  "\n                            Publish to Job Portal\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("modal", { ref: "modal", attrs: { heading: "Requisition Preview" } }, [
        _c("div", { staticClass: "bg-white rounded p-4 mb-4" }, [
          _c("div", { staticClass: "requisition-preview" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.requisition.job_profile.company.wide_logo_url }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.requisition.job_profile.title))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "mb-4",
              domProps: { innerHTML: _vm._s(_vm.adDetails) }
            }),
            _vm._v(" "),
            _c("strong", [_vm._v("Images")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid-x grid-padding-x" },
              _vm._l(_vm.images, function(image, i) {
                return _c(
                  "div",
                  {
                    key: "image_url-" + i,
                    staticClass: "cell small-6 medium-4 large-3 xlarge-2"
                  },
                  [
                    image.file_url
                      ? _c("img", {
                          attrs: {
                            src: image.file_url,
                            alt: "Req. Image #" + (i + 1)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    image.file_url_local
                      ? _c("img", {
                          attrs: {
                            src: image.file_url_local,
                            alt: "Req. Image #" + (i + 1)
                          }
                        })
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "large reveal",
        attrs: { "data-reveal": "", id: "ad-preview" }
      },
      [
        _c(
          "div",
          {
            staticClass: "close-button",
            attrs: { "data-close": "", "aria-label": "Close modal" }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _c("iframe", { staticStyle: { width: "100%", height: "75vh" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "approve-header" }, [
      _c("div", { staticClass: "header-text" }, [_vm._v("Ad Creation")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("i", { staticClass: "fas fa-image" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "approve-header" }, [
      _c("div", { staticClass: "header-text" }, [_vm._v("Comments & Approval")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2b1ea1e", { render: render, staticRenderFns: staticRenderFns })
  }
}